import React from 'react';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';

const tableRowStyles = {
  striped: {
    background: '#f0f0f0', // Lighter background color for striped rows
  },
  hover: {
    background: '#e0e0e0', // Background color for hovered rows
  },
};

export default function FinishedScheduleSection({ schedule, numGroups, timesList }) {
  const groupHeaders = Array.from({ length: numGroups }, (_, index) => `Group ${index + 1}`);

  return (
    <MDBTable striped hover>
      <MDBTableHead>
        <tr>
          <th>Start Time</th>
          {groupHeaders.map((groupHeader, index) => (
            <th key={index}>{groupHeader}</th>
          ))}
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        {schedule.map((item, itemIndex) => (
          <tr
            key={itemIndex}
            style={itemIndex % 2 === 0 ? tableRowStyles.striped : {}}
            className="table-hover"
          >
        
            <td>{timesList[itemIndex]}</td>
            {Object.values(item).map((value, index) => (
              <td key={index}>{value}</td>
            ))}
          </tr>
        ))}
      </MDBTableBody>
    </MDBTable>
  );
}


//if the activity list gets too long, the UI goes fucky wucky. fix this